import { request, requestBlob } from './request';

export const adminApi = {
  getAdminCharts: () => request('/api/admin/charts'),

  getAdminSettings: () => request('/api/admin/settings'),
  updateAdminSettings: (data) => request('/api/admin/settings', { method: 'PATCH', body: JSON.stringify(data) }),

  getAdminPushSettings: () => request('/api/admin/push-settings'),
  updateAdminPushSettings: (data) => request('/api/admin/push-settings', { method: 'PATCH', body: JSON.stringify(data) }),

  getDemoRequests: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/admin/demo-requests${qs}`);
  },
  updateDemoRequest: (id, data) =>
    request(`/api/admin/demo-requests/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  deleteDemoRequest: (id) => request(`/api/admin/demo-requests/${id}`, { method: 'DELETE' }),

  getAdminCompanies: () => request('/api/admin/companies'),
  getAdminCompany: (id) => request(`/api/admin/companies/${id}`),
  getAdminCompanyInsights: (id, params) => {
    const qs = params ? `?${new URLSearchParams(params).toString()}` : '';
    return request(`/api/admin/companies/${id}/insights${qs}`);
  },
  createAdminCompany: (data) => request('/api/admin/companies', { method: 'POST', body: JSON.stringify(data) }),
  updateAdminCompany: (id, data) =>
    request(`/api/admin/companies/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  updateAdminCompanyDomains: (id, data) =>
    request(`/api/admin/companies/${id}/domains`, { method: 'PATCH', body: JSON.stringify(data) }),
  updateAdminCompanyPlan: (id, data) =>
    request(`/api/admin/companies/${id}/plan`, { method: 'PATCH', body: JSON.stringify(data) }),
  getAdminCompanyFeatures: (id) => request(`/api/admin/companies/${id}/features`),
  updateAdminCompanyFeatures: (id, data) =>
    request(`/api/admin/companies/${id}/features`, { method: 'PATCH', body: JSON.stringify(data) }),
  getAdminCompanyOpsResetPreview: (id) => request(`/api/admin/companies/${id}/ops-reset-preview`),
  resetAdminCompanyOpsData: (id, data) =>
    request(`/api/admin/companies/${id}/ops-reset`, { method: 'POST', body: JSON.stringify(data) }),
  toggleAdminCompany: (id) => request(`/api/admin/companies/${id}/toggle`, { method: 'PATCH' }),
  setAdminCompanyAccess: (id, status) =>
    request(`/api/admin/companies/${id}/access`, { method: 'PATCH', body: JSON.stringify({ status }) }),
  resetAdminCompanyPassword: (id, data) =>
    request(`/api/admin/companies/${id}/reset-password`, { method: 'POST', body: JSON.stringify(data) }),

  getAdminPlans: () => request('/api/admin/plans'),
  updateAdminPlan: (id, data) => request(`/api/admin/plans/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),

  getAdminCountries: () => request('/api/admin/countries'),
  getAdminCountry: (id) => request(`/api/admin/countries/${id}`),
  createAdminCountry: (data) => request('/api/admin/countries', { method: 'POST', body: JSON.stringify(data) }),
  updateAdminCountry: (id, data) =>
    request(`/api/admin/countries/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  getAdminCities: (countryId) => request(`/api/admin/countries/${countryId}/cities`),
  createAdminCity: (data) => request('/api/admin/cities', { method: 'POST', body: JSON.stringify(data) }),
  updateAdminCity: (id, data) => request(`/api/admin/cities/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  getAdminRegions: (cityId) => request(`/api/admin/cities/${cityId}/regions`),
  createAdminRegion: (data) => request('/api/admin/regions', { method: 'POST', body: JSON.stringify(data) }),
  updateAdminRegion: (id, data) => request(`/api/admin/regions/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  getAdminCurrencies: () => request('/api/admin/currencies'),
  createAdminCurrency: (data) => request('/api/admin/currencies', { method: 'POST', body: JSON.stringify(data) }),
  updateAdminCurrency: (code, data) =>
    request(`/api/admin/currencies/${encodeURIComponent(code)}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteAdminCurrency: (code) =>
    request(`/api/admin/currencies/${encodeURIComponent(code)}`, { method: 'DELETE' }),

  getWorkflows: () => request('/api/workflows'),
  getWorkflow: (id) => request(`/api/workflows/${id}`),
  createWorkflow: (data) => request('/api/workflows', { method: 'POST', body: JSON.stringify(data) }),
  updateWorkflow: (id, data) => request(`/api/workflows/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteWorkflow: (id) => request(`/api/workflows/${id}`, { method: 'DELETE' }),
  cloneWorkflow: (id) => request(`/api/workflows/${id}/clone`, { method: 'POST' }),
  archiveWorkflow: (id) => request(`/api/workflows/${id}/archive`, { method: 'PATCH' }),
  activateWorkflow: (id) => request(`/api/workflows/${id}/activate`, { method: 'PATCH' }),
  createWorkflowState: (workflowId, data) => request(`/api/workflows/${workflowId}/states`, { method: 'POST', body: JSON.stringify(data) }),
  updateWorkflowState: (id, data) => request(`/api/workflows/states/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteWorkflowState: (id) => request(`/api/workflows/states/${id}`, { method: 'DELETE' }),
  createWorkflowTransition: (workflowId, data) => request(`/api/workflows/${workflowId}/transitions`, { method: 'POST', body: JSON.stringify(data) }),
  updateWorkflowTransition: (id, data) => request(`/api/workflows/transitions/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteWorkflowTransition: (id) => request(`/api/workflows/transitions/${id}`, { method: 'DELETE' }),

  getDbTables: () => request('/api/admin/db/tables'),
  getDbTable: (name) => request(`/api/admin/db/tables/${encodeURIComponent(name)}`),
  getDbTableData: (name, params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/admin/db/tables/${encodeURIComponent(name)}/data${qs}`);
  },
  downloadDbBackup: () => {
    const a = document.createElement('a');
    a.download = 'shipping-db-backup.db';
    a.style.display = 'none';
    return requestBlob('/api/admin/db/backup').then((blob) => {
      const url = URL.createObjectURL(blob);
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }).catch((err) => {
      console.error('[Backup Download Error]', err);
      throw err;
    });
  },

  getAgentMemoryStats: () => request('/api/admin/agent-memory/stats'),
  getAgentMemoryTasks: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/admin/agent-memory/tasks${qs}`);
  },
  getAgentMemoryTask: (key) => request(`/api/admin/agent-memory/tasks/${encodeURIComponent(key)}`),
  getAgentMemoryTaskContext: (key) => request(`/api/admin/agent-memory/tasks/${encodeURIComponent(key)}/context`),
  getAgentMemoryNextTask: () => request('/api/admin/agent-memory/tasks/next'),
  createAgentMemoryTask: (body) => request('/api/admin/agent-memory/tasks', { method: 'POST', body: JSON.stringify(body) }),
  updateAgentMemoryTask: (key, body) => request(`/api/admin/agent-memory/tasks/${encodeURIComponent(key)}`, { method: 'PATCH', body: JSON.stringify(body) }),
  addAgentMemoryTaskFeedback: (key, feedback) => request(`/api/admin/agent-memory/tasks/${encodeURIComponent(key)}/feedback`, { method: 'POST', body: JSON.stringify({ feedback }) }),
  deleteAgentMemoryTask: (key) => request(`/api/admin/agent-memory/tasks/${encodeURIComponent(key)}`, { method: 'DELETE' }),
  getAgentMemoryDocsTree: () => request('/api/admin/agent-memory/docs/tree'),
  getAgentMemoryDoc: (key) => request(`/api/admin/agent-memory/docs/${encodeURIComponent(key)}`),
  createAgentMemoryDoc: (body) => request('/api/admin/agent-memory/docs', { method: 'POST', body: JSON.stringify(body) }),
  updateAgentMemoryDoc: (key, body) => request(`/api/admin/agent-memory/docs/${encodeURIComponent(key)}`, { method: 'PATCH', body: JSON.stringify(body) }),
  deleteAgentMemoryDoc: (key) => request(`/api/admin/agent-memory/docs/${encodeURIComponent(key)}`, { method: 'DELETE' }),
  getAgentMemoryPrompt: () => request('/api/admin/agent-memory/prompt'),
  updateAgentMemoryPrompt: (body) => request('/api/admin/agent-memory/prompt', { method: 'PUT', body: JSON.stringify(body) }),
  getAgentMemoryLogs: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/admin/agent-memory/logs${qs}`);
  },
  getAgentMemoryFaq: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/admin/agent-memory/faq${qs}`);
  },
  getAgentMemoryFaqItem: (key) => request(`/api/admin/agent-memory/faq/${encodeURIComponent(key)}`),
  createAgentMemoryFaq: (body) => request('/api/admin/agent-memory/faq', { method: 'POST', body: JSON.stringify(body) }),
  updateAgentMemoryFaq: (key, body) => request(`/api/admin/agent-memory/faq/${encodeURIComponent(key)}`, { method: 'PATCH', body: JSON.stringify(body) }),
  deleteAgentMemoryFaq: (key) => request(`/api/admin/agent-memory/faq/${encodeURIComponent(key)}`, { method: 'DELETE' }),
};